<div odxLayout="flex gap-none" class="flex-column h-100 overflow-hidden product-list-wrapper">
  <odx-area-header class="product-header">
    <div odxLayout="flex gap-large" class="product-header-title">
      <h5 class="odx-title-5" i18n="@@productList.header" data-testid="productList.header">Produktliste</h5>
      <div odxLayout="flex gap-small" class="product-header-actions">
        @if (isCopyToClipboardVisible()) {
          <button odxButton (click)="copyProductList()" class="mobile-copy-share-link-btn">
            <odx-icon name="copy-content" size="medium" alignleft></odx-icon>
            <span i18n="@@project.btn.copyProductList">Kopieren</span>
          </button>
        }
        @if (canEditProductList()) {
          @if (editProductList) {
            <button
              odxButton
              variant="primary"
              type="button"
              class="product-list-action product-list-edit-action"
              data-testid="productList.save"
              (click)="saveProductListEdit()"
            >
              <span class="product-list-edit-action__content">
                <odx-icon name="save" size="medium" class="product-list-edit-action__icon"></odx-icon>
                <span class="product-list-edit-action__label">{{ saveAdditionalProductsLabel }}</span>
              </span>
            </button>
            <button
              odxButton
              variant="secondary"
              type="button"
              class="product-list-action product-list-edit-action product-list-edit-action--cancel"
              data-testid="productList.cancel"
              (click)="cancelProductListEdit()"
            >
              {{ cancelProductListEditLabel }}
            </button>
          } @else {
            <button
              odxButton
              variant="primary"
              type="button"
              class="product-list-action product-list-edit-action"
              data-testid="productList.edit"
              (click)="startProductListEdit()"
            >
              <span class="product-list-edit-action__content">
                <odx-icon name="edit" size="medium" class="product-list-edit-action__icon"></odx-icon>
                <span class="product-list-edit-action__label">{{ editAdditionalProductsLabel }}</span>
              </span>
            </button>
          }
        }
      </div>
    </div>

    <odx-area-header-content>
      @if (canEditProductList()) {
        <app-fgds-product-list-search [project]="project"></app-fgds-product-list-search>
      }
    </odx-area-header-content>
  </odx-area-header>

  <div odxLayout="grid gap-none" class="h-100 overflow-hidden product-list-grid">
    @if (productListDataInitialized) {
      <div odxLayout="12 7@tablet" class="container h-100 right-border scroll products-column">
        <odx-accordion multiple="true" class="bottom-border">
          <odx-accordion-item
            data-testid="productList.productsOnFloorPlan"
            [expanded]="productsOnFloorPlanExpanded"
            (expandedChange)="productsOnFloorPlanExpanded = $event"
          >
            <odx-accordion-item-title class="product-list-header-title">
              <div class="product-list-header-row">
                <span i18n="@@productList.productsOnFloorPlan">Produkte auf dem Grundrissplan</span>
                <div class="product-list-header-right">
                  <p>{{ !project.showCostFlag ? "" : (placedProductsSubtotal | currency: setCurrency()) }}</p>
                </div>
              </div>
            </odx-accordion-item-title>
            @for (group of placedGroupDisplayData; track group.key) {
              <odx-accordion-item
                data-testid="productList.groupSection"
                [expanded]="getGroupExpanded(group.key)"
                (expandedChange)="setGroupExpanded(group.key, $event)"
              >
                <odx-accordion-item-title odxLayout="flex" class="space-between">
                  <span>{{ group.label }}</span>
                  <p>
                    {{
                      !project.showCostFlag
                        ? ""
                        : ((showZrefPrices() ? group.source.zrefSubTotal : group.source.subTotal) | currency: setCurrency())
                    }}
                  </p>
                </odx-accordion-item-title>
                @for (section of group.sections; track section.key) {
                  <odx-accordion-item
                    [expanded]="getProductSectionExpanded(group.key, section.key)"
                    (expandedChange)="setProductSectionExpanded(group.key, section.key, $event)"
                  >
                    <odx-accordion-item-title odxLayout="flex" class="space-between">
                      <span>{{ section.label }}</span>
                      <div odxLayout="flex" class="product-list-header-right">
                        <p>
                          {{
                            !project.showCostFlag
                              ? ""
                              : isProductSection(section)
                                ? ((showZrefPrices() ? section.section.zrefSubTotal : section.section.subtotal)
                                  | currency: setCurrency())
                                : (section.subtotal | currency: setCurrency())
                          }}
                        </p>
                      </div>
                    </odx-accordion-item-title>
                    @if (isAttachmentInstructionsSection(section)) {
                      <app-product-table-attachment-instructions
                        [attachmentInstructions]="section.attachmentInstructions"
                        [showCosts]="project.showCostFlag"
                        [showZrefPrices]="showZrefPrices()"
                        [canEditDiscounts]="isPlacedSectionEditing(group.key, section.key)"
                        (discountChange)="
                          updateProductListDiscount(
                            $event,
                            productListEditSection.PRODUCTS_ON_FLOOR_PLAN,
                            getPlacedSectionEditKey(group.key, section.key)
                          )
                        "
                      ></app-product-table-attachment-instructions>
                    } @else if (isProductSection(section)) {
                      <app-product-table
                        [productSection]="$any(section.section)"
                        [showCosts]="project.showCostFlag"
                        [showZrefPrices]="showZrefPrices()"
                        [canEditDiscounts]="isPlacedSectionEditing(group.key, section.key)"
                        (discountChange)="
                          updateProductListDiscount(
                            $event,
                            productListEditSection.PRODUCTS_ON_FLOOR_PLAN,
                            getPlacedSectionEditKey(group.key, section.key)
                          )
                        "
                      ></app-product-table>
                    }
                  </odx-accordion-item>
                }
              </odx-accordion-item>
            }
          </odx-accordion-item>

          @if (additionalSections.length > 0) {
            <odx-accordion-item
              class="additional-products-accordion-item"
              [expanded]="additionalProductsExpanded"
              (expandedChange)="additionalProductsExpanded = $event"
            >
              <odx-accordion-item-title class="additional-products-header-title">
                <div class="additional-products-header-row">
                  <div class="additional-products-header-main">
                    <span>{{ additionalProductsLabel }}</span>
                  </div>
                  <p>{{ !project.showCostFlag ? "" : (additionalProductsSubtotal | currency: setCurrency()) }}</p>
                </div>
              </odx-accordion-item-title>
              @for (group of additionalCategoryDisplayData; track group.key) {
                <odx-accordion-item
                  class="additional-products-category-item"
                  [expanded]="getAdditionalCategoryExpanded(group.key)"
                  (expandedChange)="setAdditionalCategoryExpanded(group.key, $event)"
                >
                  <odx-accordion-item-title odxLayout="flex" class="space-between additional-products-category-title">
                    <span>{{ group.label }}</span>
                    <div odxLayout="flex" class="additional-products-category-header-right">
                      <p>
                        {{
                          !project.showCostFlag
                            ? ""
                            : ((showZrefPrices() ? group.zrefSubTotal : group.subtotal) | currency: setCurrency())
                        }}
                      </p>
                    </div>
                  </odx-accordion-item-title>
                  <app-additional-products-table
                    [configs]="group.configs"
                    [editMode]="editProductList"
                    [showCosts]="project.showCostFlag"
                    [showZrefPrices]="showZrefPrices()"
                    [currencyCode]="setCurrency()"
                    [draftQuantities]="additionalProductDrafts"
                    [emptyMessage]="getAdditionalProductsEmptyMessage(group.label)"
                    (quantityStep)="updateAdditionalProductQuantity($event.configId, $event.delta)"
                    (quantityChange)="setAdditionalProductQuantity($event.configId, $event.value)"
                    (remove)="removeAdditionalProduct($event)"
                    (discountChange)="updateProductListDiscount($event, productListEditSection.ADDITIONAL_PRODUCTS)"
                  ></app-additional-products-table>
                </odx-accordion-item>
              }
            </odx-accordion-item>
          }

          @if (projectAttachmentInstructions.length > 0) {
            <odx-accordion-item
              data-testid="productList.attachmentInstructions"
              [expanded]="attachmentInstructionsExpanded"
              (expandedChange)="attachmentInstructionsExpanded = $event"
            >
              <odx-accordion-item-title class="product-list-header-title">
                <div class="product-list-header-row">
                  <span>{{ attachmentInstructionsLabel }}</span>
                  <div class="product-list-header-right">
                    <p>
                      {{ !project.showCostFlag ? "" : (visibleProjectAttachmentInstructionsPrice | currency: setCurrency()) }}
                    </p>
                  </div>
                </div>
              </odx-accordion-item-title>
              @if (editProductList && visibleProjectAttachmentInstructions.length === 0) {
                <div class="product-list-empty-state">
                  <span>{{ getAdditionalProductsEmptyMessage(attachmentInstructionsLabel) }}</span>
                </div>
              } @else {
                <app-product-table-attachment-instructions
                  [attachmentInstructions]="visibleProjectAttachmentInstructions"
                  [showCosts]="project.showCostFlag"
                  [showZrefPrices]="showZrefPrices()"
                  [canEditDiscounts]="editProductList"
                  (discountChange)="updateProductListDiscount($event, productListEditSection.ATTACHMENT_INSTRUCTIONS)"
                ></app-product-table-attachment-instructions>
              }
            </odx-accordion-item>
          }

          <odx-accordion-item [expanded]="servicesExpanded" (expandedChange)="servicesExpanded = $event">
            <odx-accordion-item-title odxLayout="flex" class="space-between">
              <p i18n="@@global.services" data-testid="productList.services">Dienstleistungen</p>
              <p>
                {{ !project.showCostFlag ? "" : (calcServiceSubtotal() | currency: setLocalCurrency()) }}
              </p>
            </odx-accordion-item-title>
            <div class="table-scroll-wrapper">
              <table class="navinta-table">
                <thead>
                  <tr>
                    <th i18n="@@productList.servicesTable.column1.header" data-testid="productList.servicesTable.column1">
                      Pos.
                    </th>
                    <th i18n="@@productList.servicesTable.column2.header" data-testid="productList.servicesTable.column2">
                      Bezeichnung
                    </th>
                    <th i18n="@@productList.servicesTable.column3.header" data-testid="productList.servicesTable.column3">
                      Sachnummer
                    </th>
                    <th i18n="@@productList.servicesTable.column4.header" data-testid="productList.servicesTable.column4">
                      Preis
                    </th>
                  </tr>
                </thead>
                <tbody>
                  @for (serviceRow of serviceRows; track serviceRow.key) {
                    <tr>
                      <td>{{ serviceRow.position }}</td>
                      <td>{{ serviceRow.label }}</td>
                      <td>{{ serviceRow.partNumber }}</td>
                      <td>
                        {{ serviceRow.costs | currency: setLocalCurrency() }}
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </odx-accordion-item>
        </odx-accordion>

        <odx-list class="spacing-top">
          <div odxListItem>
            <div odxLayout="flex" class="space-between list-item">
              <p i18n="@@global.products" data-testid="productList.labelProducts">Produkte</p>
              <p>{{ !project.showCostFlag ? "" : (allProductsSubtotal | currency: setCurrency()) }}</p>
            </div>
          </div>
          <div odxListItem>
            <div odxLayout="flex" class="space-between list-item">
              <p i18n="@@global.services" data-testid="productList.labelServices">Dienstleistungen</p>
              <p>{{ !project.showCostFlag ? "" : (calcServiceSubtotal() | currency: setLocalCurrency()) }}</p>
            </div>
          </div>
          <div odxListItem>
            <div odxLayout="flex" class="space-between list-item">
              <p i18n="@@productList.netSum" data-testid="productList.labelNetSum">Nettosumme</p>
              @if (!project.showCostFlag) {
                <p></p>
              } @else if (areCurrenciesMixed()) {
                <p i18n="@@productList.mixedCurrencyHint" data-testid="productList.mixedCurrencyHint">
                  Kann nicht berechnet werden
                </p>
              } @else {
                <p>{{ projectTotalNetCosts | currency: setCurrency() }}</p>
              }
            </div>
          </div>
        </odx-list>
        <odx-inline-message i18n="@@productList.footer" data-testid="productList.footer">
          Die Produktliste ist kein verbindliches Angebot
        </odx-inline-message>
      </div>
    }

    <div odxLayout="12 5@tablet" class="container h-100 overflow-hidden services-column">
      <h6 class="odx-subtitle-6" i18n="@@global.services" data-testid="productList.headerServices">Dienstleistungen</h6>
      <app-services-editor
        [form]="servicesForm"
        [services]="serviceEditorEntries"
        [readonly]="(isReadOnlyUser$ | async) === true || (hasWritePermission$ | async) === false"
        [showPrice]="true"
        [pricePlaceholder]="currencyPlaceholderText"
        [currency]="setLocalCurrency()"
        [locale]="locale"
      ></app-services-editor>
    </div>
  </div>
</div>
